export enum GestaoDeCronicosStepsEnum {
  inicio = "captacao/inicio",
  detalhes = "captacao/detalhes",
  questionarioIMC = "captacao/questionario-imc",
  resultadoIMC = "captacao/resultado-imc",
  questionarioQuestoes = "captacao/questionario-questoes",
  agendarConsulta = "captacao/agendar-consulta",
  agendarConsultaConfirmeSeusDados = "captacao/agendar-consulta-confirme-seus-dados",
  loading = "captacao/loading",
}

export interface IResponseQuestionnaire {
  listaQuestoesCronicos: Array<{
    codTipoTeleOrient: string;
    idQuestTeleOrient: string;
    idQuestaoTeleOrient: string;
    idGerPacAgendato: string;
    idGerPacContr: string;
    txtQuestao: string;
    txtCompl: string;
    codTipoQuestaoTeleOrient: string;
    idQuestaoTeleOrientAnterior: string;
    resposta: string;
    idRespQuestBenef: string;
    descrTipoTeleOrient: string;
    lstQuestoesTriagem: [
      {
        idQuestaoTeleOrient: string;
        idItemQuestaoTeleOrient: string;
        txtItemQuestao: string;
        vlrItem: string;
        resposta: string;
        unidade: string;
        exemplo: string;
        icon: string;
      }
    ];
    paginacao: string;
    qtdPaginas: string;
    alinhamento: string;
  }>;
  listaQuestoesImc: Array<{
    codTipoTeleOrient: string;
    idQuestTeleOrient: string;
    idQuestaoTeleOrient: string;
    idGerPacAgendato: string;
    idGerPacContr: string;
    txtQuestao: string;
    txtCompl: string;
    codTipoQuestaoTeleOrient: string;
    idQuestaoTeleOrientAnterior: string;
    resposta: string;
    idRespQuestBenef: string;
    descrTipoTeleOrient: null;
    lstQuestoesTriagem: [
      {
        idQuestaoTeleOrient: string;
        idItemQuestaoTeleOrient: string;
        txtItemQuestao: string;
        vlrItem: string;
        resposta: string;
        unidade: string;
        exemplo: string;
        icon: null;
      }
    ];
    paginacao: string;
    qtdPaginas: string;
    alinhamento: null;
  }>;
  listaTabelaImc: Array<{
    texto: string;
    classificacao: string;
    valorInicial: number;
    valorFinal: number;
  }>;
}

export interface IGetHoursResponse {
  dtInicial: string;
  dtFinal: string;
  tipoAtend: string;
}

export interface IResultIMC {
  codAcao: string;
  idGerPacAgendato: string;
  idGerPacContr: string;
  vlrIMC: string;
}

export interface ITermResp {
  idTermoResponsabilidade: string;
  codigo: string;
  descricao: string;
  abrevSist: string;
}

export interface ITermAccept {
  indAceite: string;
  idTermoAceite: string;
}

